import { Quote } from "lucide-react";
import { TESTIMONIALS } from "../../lib/constants";

export const Testimonials = ({ heading = "Teams building with RevMatrix", items = TESTIMONIALS }) => {
  return (
    <section
      data-testid="testimonials-section"
      className="relative py-24 md:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-16">
          <div>
            <div className="rm-overline mb-4">Client Stories</div>
            <h2 className="font-display text-4xl sm:text-5xl font-extrabold tracking-tight text-white max-w-3xl">
              {heading}
            </h2>
          </div>
          <div className="rm-divider-violet" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {items.map((t, i) => (
            <figure
              key={i}
              data-testid={`testimonial-${i}`}
              className="rm-card p-8 flex flex-col"
            >
              <Quote className="h-8 w-8 text-violet-500/60 mb-5" />
              <blockquote className="font-display text-xl md:text-2xl leading-snug text-white tracking-tight mb-6">
                “{t.quote}”
              </blockquote>
              <figcaption className="mt-auto pt-4 border-t border-zinc-800">
                <div className="font-mono text-sm text-white">{t.author}</div>
                <div className="font-mono text-xs text-zinc-500 mt-1">
                  {t.role}
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
};
